import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { bootstrapApplication } from '@angular/platform-browser';
import packageJson from '../package.json' with { type: 'json' };
import { AppComponent } from './app/app.component';
import { SEU_APP_CONFIG } from './app/app.config';
import { SEU_ENVIRONMENT } from './environments/environment';

// Register German locale data
registerLocaleData(localeDe);

if (SEU_ENVIRONMENT.production) {
  enableProdMode();
}

if (SEU_ENVIRONMENT.sentryEnabled) {
  Sentry.init({
    dsn: 'https://cf2c70f400c593b5d09d7a5d9bdf90be@o4509241951846400.ingest.de.sentry.io/4509241955582032',

    environment: SEU_ENVIRONMENT.env,
    tracesSampleRate: SEU_ENVIRONMENT.env === 'prod' ? 0.2 : 1.0,
    // https://api.test.processdesigner.scheuch.com
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.test\.processdesigner\.scheuch\.com/,
      /^https:\/\/api\.processdesigner\.scheuch\.com/,
    ],
    integrations: [Sentry.browserTracingIntegration()],

    release: packageJson.version,
  });
}

bootstrapApplication(AppComponent, SEU_APP_CONFIG).catch((err) =>
  console.error(err)
);
